var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 18q-.359 0-.673-.114a1.6 1.6 0 0 1-.583-.39L2.494 9.07Q1.998 8.565 2 7.786q0-.778.493-1.282Q2.987 6 3.75 6q.763 0 1.255.504L12 13.649l6.996-7.145Q19.488 6 20.25 6t1.256.504Q22 7.008 22 7.786q0 .78-.493 1.283l-8.251 8.427a1.6 1.6 0 0 1-.583.39Q12.358 18 12 18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.984ad4b2c3878b0e0f16c13540bc8590.svg";
export { ForwardRef as ReactComponent };